import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'comparisonTooltip',
    selector: 'comparison-tooltip',
    styleUrls: ['./comparison-tooltip.component.scss'],
    templateUrl: './comparison-tooltip.component.html'
})
export class ComparisonTooltipComponent {
    @Input()
    public comparisonData: PrimitiveComparison | null = null;
    public i18NextInterpolationOptions: { escapeValue: boolean } = { escapeValue: false };
}
